<template>
    <div>
        <h1 style="font-size: 24px; color: black;">提现日报</h1>
        <div style="margin-bottom: 10px;margin-top: 25px">

            <table>
                <tr>
                    <td>
                        <span class="demonstration">日期：</span>
                        <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
:clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </td>
                    <td>
                        <el-button type="primary" class="margin-left-10"  @click="query">查询</el-button>
                    </td>
                </tr>
            </table>
        </div>

        <div>
            <el-table border :data="cashOuts">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="createDt" label="日期" :formatter="formatDateYMD"></el-table-column>
                <el-table-column prop="sum" label="提现总金额（元）"></el-table-column>
                <el-table-column prop="count4" label="提现申请次数"></el-table-column>
                <el-table-column prop="count5" label="提现成功次数"></el-table-column>
                <el-table-column prop="count2" label="提现申请人数"></el-table-column>
                <el-table-column prop="count3" label="提现成功人数"></el-table-column>
            </el-table>
        </div>

        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </div>

    </div>

</template>

<script>

import {
    cashOutStatus,
    formatDate, queryCashOutDailyReport
} from "@/http/api";
import utils from "@/utils";

export default {
    inject: ['reload'],
    name: "CashOutUserReport",
    data() {
        return {
            queryData: {
                timeDate: null,
                didNickName: null,
                status: null
            },
            cashOuts: null,
            headers: {},
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            cashOutStatus: null
        }
    },
    methods: {
        formatDate(row, column) {
            return formatDate(row, column);
        },
        formatDateYMD(row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD");
        },
        query() {
            this.queryData.page = this.page.page;
            this.queryData.size = this.page.size;
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1];
            queryCashOutDailyReport(this.queryData).then(resp => {
                this.cashOuts = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
                this.headers = {Authorization: this.$store.state.user.token};
            });
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.query();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.query();
        },
    },
    created() {
        cashOutStatus().then(resp => {
            this.cashOutStatus = resp.data.info;
            this.cashOutStatus.push({"id": null, "name": "全部"});
        });
        this.query();
    }
}
</script>

<style lang="less">
.sub {
    position: relative;
    left: 570px
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 60px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 60px;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar1 {
    width: 150px;
    height: 200px;
    display: block;
}

.elalert {
    max-width: 89%;
    left: 11%;
}

.iconSize {
    font-size: 14px;
    font-weight: normal;
}

</style>
